import { TextField } from '@material-ui/core';
import { Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ErrorMessageEntity } from 'src/api/useEnqueteStatusPageApi';
import CloseButton from 'src/components/app-components/CloseButton';

export type FormValues = {
  emails: string;
};

interface Props {
  onClose: () => void;
  errorReport: ErrorMessageEntity[] | string;
}

/**
 * 休職者レポート詳細コンポーネント
 *
@param {function} onClose:モーダルやダイアログを閉じるためのコールバック関数
@param {string | Array<{ description: string }>} errorReport:エラーレポートの表示内容
@returns {JSX.Element}:休職者登録 警告メッセージダイアログ 
*/
const ReturndReportContent = ({ onClose, errorReport }: Props) => {
  const { t } = useTranslation();
  let message: string = '';
  if (typeof errorReport === 'string') {
    message = errorReport;
  } else {
    if (errorReport.length > 0) {
      errorReport.forEach((error) => {
        message = message + error.description + '\r\n';
      });
      message = message.trim();
    }
  }

  return (
    <>
      <Typography id="return-message">{t('enqueteCreate.returndReportContent.returnedRegistLabel')}</Typography>
      <Grid container>
        <TextField fullWidth type="text" multiline value={message} rows={10} />
      </Grid>
      <Grid container mt={2}>
        <Grid item xs={6} justifyContent={'left'}>
          <Stack direction={'row'} spacing={1}>
            <CloseButton onClose={onClose} color="primary" />
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default ReturndReportContent;
